import API_URL from '@/config/api';
import { extractApiError } from '@/utils/apiError';

const base = (userId, brand) => `${API_URL}/api/staff/approvals/${userId}/${brand}`;

async function handle(res) {
  if (!res.ok) throw new Error(await extractApiError(res));
  return res.json();
}

const json = (method, url, body) => fetch(url, { method, credentials: 'include', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) }).then(handle);
const form = (url, fd) => fetch(url, { method: 'POST', credentials: 'include', body: fd }).then(handle);

export const assistApi = {
  summary: () => fetch(`${API_URL}/api/staff/approvals/summary`, { credentials: 'include' }).then(handle),
  get: (u, b) => fetch(`${base(u, b)}/assist`, { credentials: 'include' }).then(handle),
  stage2: (u, b, body) => json('PUT', `${base(u, b)}/assist/stage2`, body),
  stage3: (u, b, body) => json('PUT', `${base(u, b)}/assist/stage3`, body),
  stage4: (u, b, fd) => form(`${base(u, b)}/assist/stage4`, fd),
  stage5: (u, b, body) => json('PUT', `${base(u, b)}/assist/stage5`, body),
  stage6Photo: (u, b, fd) => form(`${base(u, b)}/assist/stage6/photo`, fd),
  stage6Complete: (u, b, body) => json('POST', `${base(u, b)}/assist/stage6/complete`, body),
  stage7: (u, b, body) => json('POST', `${base(u, b)}/assist/stage7`, body),
  approveNow: (u, b, body) => json('POST', `${base(u, b)}/approve-now`, body),
  certUrl: (u, b) => `${API_URL}/api/installer/approvals/${b}/stage4/certificate?user_id=${u}`,
  photoUrl: (b, id) => `${API_URL}/api/installer/approvals/${b}/stage6/photo/${id}`,
};

export const BRANDS = [
  { id: 'probound', label: 'ProBound', accent: 'text-[#7A0B7A]', chip: 'bg-purple-100 text-purple-800 border-purple-200' },
  { id: 'proepoxy', label: 'ProEpoxy', accent: 'text-[#2F5E96]', chip: 'bg-blue-100 text-blue-800 border-blue-200' },
  { id: 'prodecor', label: 'ProDecor', accent: 'text-emerald-700', chip: 'bg-emerald-100 text-emerald-800 border-emerald-200' },
];

export const OVERALL = {
  not_started: { label: 'Not started', cls: 'bg-gray-100 text-gray-600 border-gray-200' },
  in_progress: { label: 'In progress', cls: 'bg-amber-50 text-amber-800 border-amber-200' },
  submitted: { label: 'Under review', cls: 'bg-sky-50 text-sky-800 border-sky-200' },
  approved: { label: 'Approved', cls: 'bg-emerald-50 text-emerald-800 border-emerald-200' },
  rejected: { label: 'Rejected', cls: 'bg-rose-50 text-rose-800 border-rose-200' },
  lapsed: { label: 'Lapsed', cls: 'bg-orange-50 text-orange-800 border-orange-200' },
};

export const STAGE_STATUS = {
  not_started: { label: 'Not started', cls: 'text-gray-500 bg-gray-100' },
  in_progress: { label: 'In progress', cls: 'text-amber-800 bg-amber-100' },
  under_review: { label: 'Under review', cls: 'text-sky-800 bg-sky-100' },
  complete: { label: 'Complete', cls: 'text-emerald-800 bg-emerald-100' },
  action_required: { label: 'Action required', cls: 'text-rose-800 bg-rose-100' },
  rejected: { label: 'Rejected', cls: 'text-rose-800 bg-rose-100' },
};

export const STAGE5_LABELS = {
  probound: { material: 'Resin used', blend: 'Aggregate blend' },
  proepoxy: { material: 'Top coat / system used', blend: 'Pigment / flake / effect' },
  prodecor: { material: 'Finish used', blend: 'Colour / effect' },
};
